import { format, parseISO, isPast } from 'date-fns';
import { Certification } from '../types';

// Format certification date
export function formatCertificationDate(isoDate: string): string {
  return format(parseISO(isoDate), 'MMM dd, yyyy');
}

// Check if certification is expired
export function isCertificationExpired(cert: Certification): boolean {
  if (!cert.expiryDate) return false;
  return isPast(parseISO(cert.expiryDate));
}

// Get certification status color
export function getCertificationStatusColor(status: Certification['status']): string {
  switch (status) {
    case 'active':
      return 'success';
    case 'expired':
      return 'danger';
    case 'pending':
      return 'warning';
    default:
      return 'medium';
  }
}

// Get certification status label
export function getCertificationStatusLabel(status: Certification['status']): string {
  switch (status) {
    case 'active':
      return 'Active';
    case 'expired':
      return 'Expired';
    case 'pending':
      return 'Pending';
    default:
      return 'Unknown';
  }
}

